import React from 'react';

function NotFoundPage() {
    return (
        <div style={{ textAlign: "center", marginTop: "5rem" }}>
            <h1>404</h1>
            <p>Oops! The page you are looking for does not exist.</p>
        </div>
    );
}

export default NotFoundPage;